export default "/images/vendor/flag-icon-css/flags/4x3/kg.svg?1fe994c1e99757dce0236378b8704696";